import React from "react";
import { Treeview } from "@softura/customcomponent";
import "./Treeview.scss";
interface IProps {
  TreeviewData?: any;
  ContextMenuData1?: any;
}
const TreeviewContainer = ({ TreeviewData, ContextMenuData1 }: IProps) => {
  return ( 
    <Treeview
      TreeviewData={TreeviewData}
      ContextMenuData={ContextMenuData1}
      className="custom-treeview"
     data-attribute="Treeview_Default_Treeview" />
  );
};
export default TreeviewContainer;
